import { render, staticRenderFns } from "./TruckTypePicker.vue?vue&type=template&id=410f860d&"
import script from "./TruckTypePicker.vue?vue&type=script&lang=js&"
export * from "./TruckTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./TruckTypePicker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports